import { useEffect } from "react";
import extractedStylesUrl from "../styles/upsells/extracted-styles.css?url";

export const useUpsellStyles = () => {
  useEffect(() => {
    // Always ensure the shared stylesheet is present.
    let sharedLink = document.querySelector<HTMLLinkElement>(
      'link[data-upsell-style="shared"]',
    );
    if (!sharedLink) {
      sharedLink = document.createElement("link");
      sharedLink.rel = "stylesheet";
      sharedLink.setAttribute("data-upsell-style", "shared");
      document.head.appendChild(sharedLink);
    }
    sharedLink.href = extractedStylesUrl;
  });
};
